exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p[data-v-8b846b14]{line-height:.7}[data-v-8b846b14] .attachments,[data-v-8b846b14] .body,[data-v-8b846b14] .interactive-content{padding:2px 1rem!important;margin:0!important}[data-v-8b846b14] .body p{line-height:1}[data-v-8b846b14] .Email .attachments ul li a>span,a.fake-link[data-v-8b846b14]{color:#1870c7;background:hsla(0,0%,100%,.9)}.buffer[data-v-8b846b14]{border-top:.071429rem solid #ccc}", ""]);

// exports
